module.exports = __webpack_public_path__ + "static/img/label.a64a163.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/votefriend/images/label.png
// module id = 2978
// module chunks = 1